// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-GeoField-styles--normal--ktsXV,
.src-components-GeoField-styles--inline--edft2 {
  position: relative;
  display: block;
  margin-top: 15px;
}

@media screen and (min-width: 768px) {

.src-components-GeoField-styles--normal--ktsXV,
.src-components-GeoField-styles--inline--edft2 {
    margin-top: 20px;
}
  }

.src-components-GeoField-styles--normal--ktsXV:first-child {
    margin-top: 0;
  }

.src-components-GeoField-styles--inline--edft2:first-child {
    margin-top: 0;
  }

div.src-components-GeoField-styles--radio--SMMJg {
  margin-top: 15px;
}

@media screen and (min-width: 768px) {

div.src-components-GeoField-styles--radio--SMMJg {
    margin-top: 20px;
}
  }

div.src-components-GeoField-styles--radio--SMMJg:first-child {
    margin-top: 0;
  }

@media screen and (min-width: 768px) {

div.src-components-GeoField-styles--radio--SMMJg:first-child {
      margin-top: 10px;
  }
    }

@media screen and (min-width: 768px) {
  .src-components-GeoField-styles--inline--edft2 {
    width: 290px;
  }
}

.src-components-GeoField-styles--muted--kpwps {
  margin-left: 10px;
  opacity: 0.4;
}

.src-components-GeoField-styles--suggestItem--MYtFp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/GeoField/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;;EAEE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AASlB;;AAPE;;AANF;;IAOI,gBAAgB;AAMpB;EALE;;AAEA;IACE,aAAa;EACf;;AAFA;IACE,aAAa;EACf;;AAGF;EACE,gBAAgB;AAalB;;AAXE;;AAHF;IAII,gBAAgB;AAUpB;EATE;;AAEA;IACE,aAAa;EAKf;;AAHE;;AAHF;MAII,gBAAgB;EAEpB;IADE;;AAIJ;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.normal,\n.inline {\n  position: relative;\n  display: block;\n  margin-top: 15px;\n\n  @media (--desktop) {\n    margin-top: 20px;\n  }\n\n  &:first-child {\n    margin-top: 0;\n  }\n}\n\ndiv.radio {\n  margin-top: 15px;\n\n  @media (--desktop) {\n    margin-top: 20px;\n  }\n\n  &:first-child {\n    margin-top: 0;\n\n    @media (--desktop) {\n      margin-top: 10px;\n    }\n  }\n}\n\n@media (--desktop) {\n  .inline {\n    width: 290px;\n  }\n}\n\n.muted {\n  margin-left: 10px;\n  opacity: 0.4;\n}\n\n.suggestItem {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"normal": `src-components-GeoField-styles--normal--ktsXV`,
	"inline": `src-components-GeoField-styles--inline--edft2`,
	"radio": `src-components-GeoField-styles--radio--SMMJg`,
	"muted": `src-components-GeoField-styles--muted--kpwps`,
	"suggestItem": `src-components-GeoField-styles--suggestItem--MYtFp`
};
module.exports = ___CSS_LOADER_EXPORT___;
